<template>
  <div class="faq-item">
    <div class="faq-question" v-b-toggle="id">
      <b-icon-chevron-down />
      <span>{{ question }}</span>
    </div>
    <b-collapse :visible="$route.hash === `#${id}`" :id="id" :accordion="accordion">
      <div class="faq-answer">
        <slot/>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'FaqItem',

  props: {
    id: {
      type: String,
      required: true,
    },

    question: {
      type: String,
      required: true,
    },

    accordion: {
      type: String,
      required: false,
      default: undefined,
    },
  },
};
</script>

<style lang="scss">
.faq-item {
  border: 1px solid lightgrey;

  .faq-question {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

    font-weight: bold;
    font-size: larger;

    padding: .5rem .75rem;

    outline: none;

    cursor: pointer;

    .b-icon {
      transition: transform 450ms ease;
      transform: rotate(0deg);

      margin-right: 0.75rem;
    }

    &.not-collapsed {
       border-bottom: 1px solid lightgray;

      .b-icon {
        transform: rotate(180deg);
      }
    }

    span {
      flex: 1 1 auto;
    }
  }

  .faq-answer {
    padding: 0.75rem;
  }
}
</style>
